const BannerSection = () => {
    return (<section id="about_banner" style={{ backgroundImage: `url('./assets/images/home-banner.png')` }}>
        <div class="container">
            <h1>About US</h1>
        </div>
    </section>)
}

export default BannerSection;